import { render } from "./TableItem.vue?vue&type=template&id=36591fea&scoped=true&ts=true"
import script from "./TableItem.vue?vue&type=script&lang=ts"
export * from "./TableItem.vue?vue&type=script&lang=ts"

import "./TableItem.vue?vue&type=style&index=0&id=36591fea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\agui4\\Documents\\projects\\caner-server-status\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36591fea"]])

export default __exports__